module.exports = __webpack_public_path__ + "img/account_pc_01.cc67d361.png";